import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Country } from '../../models/country';
import { AllCountriesState } from '../reducers/all-countries';

export const getAllCountriesStore =
  createFeatureSelector<AllCountriesState>('allCountries');

export const getAllCountries = createSelector(
  getAllCountriesStore,
  (state: AllCountriesState): Country[] => state.allCountries,
);
export const areAllCountriesLoading = createSelector(
  getAllCountriesStore,
  (state: AllCountriesState): boolean => state.isLoading,
);
export const areAllCountriesLoaded = createSelector(
  getAllCountriesStore,
  (state: AllCountriesState): boolean => state.isLoaded,
);
